import React from 'react'
import styled from 'styled-components';
import ProjectCard from './ProjectCard';
import pic from "./Images/priscah9.PNG";
import hanaka from "./Images/imagesfresh.jpg";
import klassisch from "./Images/3.b8bc7833bea6e52eb9d7.jpg";
import disney from "./Images/Capture11.PNG"
import easyPay from "./Images/easy.jpg"

const Projects = () => {
  return (
    <Container>
      <H1>MY PROJECTS</H1>
      <Wrapper>
        <ProjectCard image={hanaka} description="Connecting you to artisans within your location" title="Hanaka" link="https://enchanting-khapse-a4050a.netlify.app"/>
        <ProjectCard title="EasyPay" description="seamless payment solution between employer and employee" link="https://naija-sd-gs2023-easy-pay.vercel.app/" image={easyPay} />
        <ProjectCard image={klassisch} title="Klassisch FA" description="football association in Ajegunle, Lagos Nigeria" link="https://klassischfootballclub.netlify.app/" />
        <ProjectCard image={pic} title="Priscah's Hub" description="E-commerce website for sales of clothings" link="https://priscah's-hub.netlify.app"/>
        <ProjectCard title="Disney Plus" description="Download disney movies" image={disney} link="https://disney-plus.netlify.app" />
        {/* <ProjectCard/> */}
      </Wrapper>
    </Container>
  )
}

export default Projects;

const Container = styled.div`
width: 100%;
height: auto;
background-color: black;
display: flex;
flex-direction: column;
align-items: center;
padding: 80px 0 60px 0;
`;
const Wrapper = styled.div`
width: 90%;
height: 90%;
/* background-color: green; */
display :flex;
justify-content: space-between;
flex-wrap: wrap;

@media Screen and (max-width: 768px){
  justify-content: center;
}
`;
const H1 = styled.h1`
color: whitesmoke;
font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
/* color:#2b2c2c; */
font-size: 28px;
`;